export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="hairline-b border-b"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-28 grid grid-cols-12 gap-8 md:gap-12">
        <div className="col-span-12 md:col-span-3">
          <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
            02 — About
          </div>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-[0.95]">
            On the<br />record.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-7 md:col-start-5 space-y-6 reveal">
          <p className="text-2xl md:text-4xl font-medium tracking-tight leading-[1.15] text-[var(--ink)]">
            I build brands with business in mind.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-[var(--muted)]">
            Over the past eight years, I&apos;ve grown from managing individual
            client accounts to leading multi-crore businesses, mentoring
            high-performing teams and delivering integrated campaigns for some of India&apos;s most recognised healthcare, retail and FMCG brands.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-[var(--muted)]">
            Today, as Group Head at Social Panga, I lead a{" "}
            <span className="text-[var(--ink)] font-medium">₹4Cr+ portfolio</span>,
            oversee a team of nine, and work closely with clients to solve
            business problems through integrated marketing across Digital,
            Television, Print, OOH, Experiential, Influencer Marketing and
            Production.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-[var(--muted)]">
            Whether the objective is driving revenue, launching a product,
            changing perception or creating culture-first campaigns —{" "}
            <span className="text-[var(--ink)] font-medium">
              execution is where strategy earns its credibility.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};
